import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import HeaderEN from "../../headerEN/headeren";
import FooterEN from "../../footerEN/footer";
import './riskinspectionservices.scss';

const RiskInspectionServices = () => {

  useEffect(() => {
    const handleContextmenu = e => {
        e.preventDefault()
    }
    document.addEventListener('contextmenu', handleContextmenu)
    return function cleanup() {
        document.removeEventListener('contextmenu', handleContextmenu)
    }
  
  },[])

  const [tabsList, setTabsList] = useState([{ text: "Travel Insurance", url: "travel-insurance" }, { text: "Life Insurance", url: "life-insurance" }])
  const [tab, setTab] = useState(0)

  return (
    <div class="main-fluid">
     <HeaderEN />
      {/* DESK TOP AND TABS SECTION STARTS HERE */}
      <div class="d-none d-md-block">
        <div class="riskinspetserv-tab-imagebannermain-en">
          <div class="riskinspetserv-banner-con-en">
            <div class="riskinspetservtab-banne-sec-en">
              <h1 class="riskinspetserv-banner-heading-en">Valued Services</h1>

              {/* TAB BUTTON SECTION STARTS HERE */}
              <div class="grpacc-covinsu-tab-btn-en">
                <div class="grpacc-insu-tab-btn-item-active-en" onClick={() => window.location.href = "risk-inspection-services"}>Risk Inspection Services</div>
                <div class="grpacc-insu-tab-btn-item-en" onClick={() => window.location.href = "insurance-audits"}>Insurance Audits</div>
                <div class="grpacc-insu-tab-btn-item-en" onClick={() => window.location.href = "valuation-services"}>Valuation services</div>
                <div class="grpacc-insu-tab-btn-item-en" onClick={() => window.location.href = "thermography-testing-insurance"}>Thermography Testing</div>
                {/* <div class="grpacc-insu-tab-btn-item-en" onClick={() => window.location.href = "policy-renewalalerts"}>Policy Renewal Alerts</div> */}
                <div class="grpacc-insu-tab-btn-item-en" onClick={() => window.location.href = "employee-wellness-program"}>Employee Wellness Program</div>
              </div>
              {/* TAB BUTTON SECTION ENDS HERE */}

              <div class="best-responsive-tab" id="myExampleBestResponsiveTab1" role="tablist" data-target-content="#myExampleTabsContent">
                {/* {
                  tabsList && tabsList.length ? tabsList.map(( each, index ) => <div data-target-index={index} className={index == tab ? "active" : "def"} onClick={() => {
                    setTab(index)
                    window.location.href = "personalinsurance/" + each.url
                  }}>{each.text}</div>) : null

                } */}
                {/* <div data-target-index="0">Travel Insurance</div>
                <div data-target-index="1" onClick={() => window.location.href = "personalinsurance/life-insurance"}>Life Insurance</div>
                <div data-target-index="2">Personal Accident Insurance</div>
                <div data-target-index="3">Relocation Insurance</div>
                <div data-target-index="4">Health Insurance</div>
                <div data-target-index="5">Art insurance</div>
                <div data-target-index="6">Golf Insurance</div>
                <div data-target-index="7">Motor Insurance</div>
                <div data-target-index="8">Housemaid Insurance</div>
                <div data-target-index="9">Home Insurance</div>
                <div data-target-index="10">Yacht Insurance</div> */}


              </div>
            </div>
          </div>
        </div>
        <div class="riskinspetserv-banner-con-en">
          <div class="riskinspetserv-bdy-en">
          {/* <h2 class="pagetitle-en">Risk Inspection Services</h2> */}
            <div class="riskinspetserv-dflex-en">
              {/* LEFT SIDE IMAGE SECTION STARTS HERE */}
              <div class="riskinspetserv-dlex-lft-en">
                <h2 class="pagetitle-en">Risk Inspection Services</h2>

                <p class="riskinspetserv-pg-txt-con">We facilitate risk inspection surveys, from underwriting perspective with emphasis on safety and risk management, through highly skilled surveyors & risk engineers. Highlights of such risk inspection surveys include :</p>

                <div class="riskinspetserv-keypoint-en">
                  <div class="riskinspetserv-keypoint-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div class="riskinspetserv-keypoint-item-en">To analyze risk prone areas and activities in your business operations.</div>

                  <div class="riskinspetserv-keypoint-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div class="riskinspetserv-keypoint-item-en">Inspection of electricity wirings, fire extinguishers, house-keeping, stacking etc.</div>
                  
                  <div class="riskinspetserv-keypoint-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div class="riskinspetserv-keypoint-item-en">Inspection of ground levels, soil conditions, structure strengths.</div>
                  
                  <div class="riskinspetserv-keypoint-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div class="riskinspetserv-keypoint-item-en">Route survey inspections for over dimensional consignments.</div>
                  
                  <div class="riskinspetserv-keypoint-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div class="riskinspetserv-keypoint-item-en">Suggest risk improvement / loss mitigation measures.</div>
                  
                  <div class="riskinspetserv-keypoint-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div class="riskinspetserv-keypoint-item-en">Collection of information related to previous major losses.</div>
                  
                  <div class="riskinspetserv-keypoint-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div class="riskinspetserv-keypoint-item-en">Inspection carried out by experienced engineers.</div>
                </div>

                <p class="riskinspetserv-pg-txt-con">We look forward to safeguard your risk through our Risk Inspection Services, Please contact us for further details or discussions on our offerings.</p>

              </div>
              {/* LEFT SIDE IMAGE SECTION ENDS HERE */}
              {/* RIGHT SIDE IMAGE SECTION STARTS HERE */}
              <div class="riskinspetserv-dlex-rgt-en">
              <img src={process.env.PUBLIC_URL + "/riskmanagementservices_images/tab_images/risk_inspection_services.png"} alt="risk inspection services" />
              </div>
              {/* RIGHT SIDE IMAGE SECTION ENDS HERE */}
            </div>

              <h3 class="riskinspetserv-whykrinsu-title-en">Why KR Insurance Services ?</h3>
                <div class="clearfix"></div>

                <div class="riskinspetserv-pins-list-dksp-en">
                  <div class="riskinspetserv-lt-one-dksp-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Competitive Terms</div>
                  <div class="riskinspetserv-lt-two-dksp-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Prompt Claim Services</div>
                  <div class="riskinspetserv-lt-one-dksp-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Wide Quote Comparisons</div>
                  <div class="riskinspetserv-lt-two-dksp-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Best Insurance Industry Practices</div>
                </div>                
          </div>
        </div>
      </div>
      {/* DESK TOP AND TABS SECTION ENDS HERE */}

      {/* MOBILE PAGE STARTS HERE */}
      <div class="riskinspetserv-tab-imagebannermain-en hidden-desktop hidden-md-device hidden-lg">
        <div class="dropdown-sec">
          <select class="form-select" onChange={(e) => window.location.href = e.target.value}>
            <option value={"risk-inspection-services"} selected class="active">Risk Inspection Services</option>
            <option value={"insurance-audits"}>Insurance Audits</option>
            <option value={"valuation-services"}>Valuation services</option>
            <option value={"thermography-testing-insurance"}>Thermography Testing</option>
            {/* <option value={"policy-renewalalerts"}>Policy Renewal Alerts</option> */}
            <option value={"employee-wellness-program"}>Employee Wellness Program</option>
          </select>
        </div>
        <div class="riskinspetserv-mob-main-en">
          <h1 class="riskinspetserv-banner-heading-en">Risk Inspection Services</h1>
          <div class="riskinspetserv-mob-img-en">
            <img src={process.env.PUBLIC_URL + "/riskmanagementservices_images/tab_images/risk_inspection_services.png"} alt="risk inspection services" />
          </div>

          <p class="riskinspetserv-mob-txt-en">We facilitate risk inspection surveys, from underwriting perspective with emphasis on safety and risk management, through highly skilled surveyors & risk engineers. Highlights of such risk inspection surveys include :</p>

          <div class="riskinspetserv-pins-list-mob-en">
            <div class="riskinspetserv-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="riskinspetserv-pins-list-mob-item-en">To analyze risk prone areas and activities in your business operations.</div>
            <div class="riskinspetserv-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="riskinspetserv-pins-list-mob-item-en">Inspection of electricity wirings, fire extinguishers, house-keeping, stacking etc.</div>
            <div class="riskinspetserv-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="riskinspetserv-pins-list-mob-item-en">Inspection of ground levels, soil conditions, structure strengths.</div>
            <div class="riskinspetserv-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="riskinspetserv-pins-list-mob-item-en">Route survey inspections for over dimensional consignments.</div>
            <div class="riskinspetserv-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="riskinspetserv-pins-list-mob-item-en">Suggest risk improvement / loss mitigation measures.</div>
            <div class="riskinspetserv-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="riskinspetserv-pins-list-mob-item-en">Collection of information related to previous major losses.</div>
            <div class="riskinspetserv-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="riskinspetserv-pins-list-mob-item-en">Inspection carried out by experienced engineers.</div>
          </div>

          <p class="riskinspetserv-mob-txt-en">We look forward to safeguard your risk through our Risk Inspection Services, Please contact us for further details or discussions on our offerings.</p>

          <h3 class="riskinspetserv-whykrinsu-mob-title-en">Why KR Insurance Services ?</h3>

          <div class="riskinspetserv-mob-whykrlist-en">
            <div class="riskinspetserv-mob-whykrlist-item-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Competitive Terms</div>
            <div class="riskinspetserv-mob-whykrlist-item-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Prompt Claim Services</div>
            <div class="riskinspetserv-mob-whykrlist-item-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Wide Quote Comparisons</div>
            <div class="riskinspetserv-mob-whykrlist-item-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Best Insurance Industry Practices</div>
          </div>          
        </div>
      </div>
      {/* MOBILE PAGE ENDS HERE */}

      {/* FOOTER SECTION STARTS HERE */}
      <FooterEN />
      {/* FOOTER SECTION ENDS HERE */}
    </div>
  );
}

export default RiskInspectionServices;
